import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, Users, Award, Shield } from 'lucide-react';
import { companyInfo, services, clients } from '../data/mock';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <img 
            src="https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/t098c1ly_3b810e4c-3561-41cb-820d-e8db59828a11.jpg"
            alt="Segnaletica professionale"
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content container">
          <div className="hero-text">
            <h1 className="display-title hero-title-white">
              Segnaletica <span className="text-brand-orange">Professionale</span> per Ogni Esigenza
            </h1>
            <p className="body-large hero-description-white" style={{ maxWidth: '600px', marginTop: '2rem' }}>
              Soluzioni complete di segnaletica stradale e industriale. 
              Dalla consulenza alla realizzazione, fino alla manutenzione.
            </p>
            <div className="hero-cta" style={{ marginTop: '2.5rem' }}>
              <Link 
                to="/contatti" 
                className="btn-primary"
                onClick={() => {
                  setTimeout(() => window.scrollTo(0, 0), 100);
                }}
              >
                Richiedi Preventivo
                <ArrowRight size={20} />
              </Link>
              <Link to="/servizi" className="btn-secondary">
                Scopri i Servizi
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section section section-blue-tint">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <Users className="stat-icon" size={40} />
              <div className="stat-number">17+</div>
              <div className="stat-label">Clienti Prestigiosi</div>
            </div>
            <div className="stat-item">
              <Award className="stat-icon" size={40} />
              <div className="stat-number">100%</div>
              <div className="stat-label">Materiali Certificati</div>
            </div>
            <div className="stat-item">
              <Shield className="stat-icon" size={40} />
              <div className="stat-number">24/7</div>
              <div className="stat-label">Assistenza Clienti</div>
            </div>
            <div className="stat-item">
              <CheckCircle className="stat-icon" size={40} />
              <div className="stat-number">6 Fasi</div>
              <div className="stat-label">Processo Qualità</div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview-section section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">I Nostri Servizi</h2>
            <div className="accent-line"></div>
            <p className="body-large text-secondary" style={{ marginTop: '1rem', maxWidth: '700px' }}>
              Offriamo un servizio completo che copre ogni aspetto della segnaletica professionale
            </p>
          </div>

          <div className="services-grid">
            {services.slice(0, 3).map((service) => (
              <div key={service.id} className="service-card card">
                <div className="service-card-content">
                  <h3 className="subsection-title" style={{ fontSize: '1.5rem' }}>{service.title}</h3>
                  <p className="body-regular text-secondary" style={{ marginTop: '1rem' }}>
                    {service.description}
                  </p>
                  <ul className="service-features">
                    {service.features.slice(0, 3).map((feature, idx) => (
                      <li key={idx} className="service-feature">
                        <CheckCircle size={16} className="feature-icon" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/servizi" className="btn-primary">
              Tutti i Servizi
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

      {/* How We Work */}
      <section className="how-we-work-section section section-blue-tint">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Come <span className="text-brand-red">Lavoriamo</span></h2>
            <div className="accent-line"></div>
            <p className="body-large text-secondary" style={{ marginTop: '1rem', maxWidth: '700px' }}>
              Un metodo strutturato che garantisce precisione, efficienza e continuità operativa
            </p>
          </div>

          <div className="process-grid">
            <div className="process-card">
              <div className="process-number">01</div>
              <h3 className="process-title">Analisi</h3>
              <p className="process-description">Comprendiamo le tue esigenze</p>
            </div>
            <div className="process-card">
              <div className="process-number">02</div>
              <h3 className="process-title">Sopralluogo</h3>
              <p className="process-description">Ispezione accurata del sito</p>
            </div>
            <div className="process-card">
              <div className="process-number">03</div>
              <h3 className="process-title">Progettazione</h3>
              <p className="process-description">Soluzioni personalizzate</p>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/come-lavoriamo" className="btn-secondary">
              Scopri il Processo Completo
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

      {/* Company Presentation Section */}
      <section className="company-presentation-section section">
        <div className="container">
          <div className="presentation-box">
            <h2 className="presentation-title">
              Soluzioni professionali per la <span className="text-brand-orange">segnaletica</span> e la <span className="text-brand-blue">sicurezza</span>
            </h2>
            
            <div className="presentation-content">
              <p className="presentation-intro">
                Abbiamo il piacere di presentarvi il Gruppo <strong>SI.SA. LINE</strong>, partner affidabile per la progettazione, fornitura e posa di segnaletica stradale e di sicurezza in ambienti logistici, commerciali e residenziali. Operiamo su tutto il territorio nazionale, con interventi rapidi e personalizzati, con l'obiettivo di candidarci come vostri futuri partner nella fornitura e posa di segnaletica e cartellonistica stradale.
              </p>

              <div className="experience-badge">
                <div className="badge-number">40+</div>
                <div className="badge-text">Anni di Esperienza</div>
              </div>

              <p className="presentation-description">
                Da oltre <strong>40 anni</strong> operiamo su scala nazionale, offrendo soluzioni su misura per la gestione della viabilità e della sicurezza in ambienti logistici, commerciali e residenziali. Collaboriamo con realtà di primo piano nei settori della Grande Distribuzione Organizzata, della Logistica e delle Aziende Private e Interporti.
              </p>

              <div className="sectors-grid">
                <div className="sector-item">
                  <div className="sector-icon">GDO</div>
                  <div className="sector-label">Grande Distribuzione Organizzata</div>
                </div>
                <div className="sector-item">
                  <div className="sector-icon">LOG</div>
                  <div className="sector-label">Logistica</div>
                </div>
                <div className="sector-item">
                  <div className="sector-icon">CPM</div>
                  <div className="sector-label">Corporate & Property Management</div>
                </div>
                <div className="sector-item">
                  <div className="sector-icon">INT</div>
                  <div className="sector-label">Interporti</div>
                </div>
              </div>

              <p className="presentation-commitment">
                Siamo pronti a mettere la nostra competenza al servizio della vostra struttura, garantendo <strong>qualità</strong>, <strong>affidabilità</strong> e rispetto delle <strong>tempistiche</strong> e dell'<strong>ambiente</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section section-blue-tint">
        <div className="container">
          <div className="cta-card">
            <h2 className="section-title" style={{ textAlign: 'center' }}>
              Pronto a Iniziare il Tuo Progetto?
            </h2>
            <p className="body-large text-secondary" style={{ textAlign: 'center', marginTop: '1.5rem', maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
              Contattaci oggi per una consulenza gratuita e un preventivo personalizzato
            </p>
            <div style={{ textAlign: 'center', marginTop: '2.5rem', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link 
                to="/contatti" 
                className="btn-primary"
                onClick={() => {
                  setTimeout(() => window.scrollTo(0, 0), 100);
                }}
              >
                Contattaci Ora
                <ArrowRight size={20} />
              </Link>
              <a href="tel:+393939923354" className="btn-secondary">
                Chiama Subito
              </a>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .home-page {
          padding-top: 80px;
        }

        /* Hero Section */
        .hero-section {
          position: relative;
          min-height: 90vh;
          display: flex;
          align-items: center;
          overflow: hidden;
        }

        .hero-title-white {
          color: white !important;
        }

        .hero-description-white {
          color: rgba(255, 255, 255, 0.9) !important;
        }

        .hero-background {
          position: absolute;
          inset: 0;
          z-index: 0;
        }

        .hero-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.4));
        }

        .hero-content {
          position: relative;
          z-index: 1;
          padding: var(--space-lg) 0;
        }

        .hero-text {
          max-width: 800px;
        }

        .hero-cta {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        /* Stats Section */
        .stats-section {
          background: var(--bg-section-alternate);
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: var(--space-md);
        }

        @media (max-width: 1024px) {
          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .stats-grid {
            grid-template-columns: 1fr;
          }
        }

        .stat-item {
          text-align: center;
          padding: var(--space-md);
        }

        .stat-icon {
          color: var(--brand-orange);
          margin: 0 auto 1rem;
        }

        .stat-number {
          font-size: 3rem;
          font-weight: 900;
          color: var(--text-primary);
          line-height: 1;
        }

        .stat-label {
          margin-top: 0.5rem;
          color: var(--text-secondary);
          font-size: 1rem;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        /* Services Preview */
        .section-header {
          text-align: center;
          margin-bottom: var(--space-lg);
        }

        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--space-md);
          margin-top: var(--space-lg);
        }

        @media (max-width: 1024px) {
          .services-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .services-grid {
            grid-template-columns: 1fr;
          }
        }

        .service-card {
          padding: var(--space-md);
        }

        .service-card-content {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .service-features {
          list-style: none;
          margin-top: 1.5rem;
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .service-feature {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          color: var(--text-secondary);
          font-size: 0.95rem;
        }

        .feature-icon {
          color: var(--brand-orange);
          flex-shrink: 0;
        }

        /* Process Grid */
        .process-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--space-md);
          margin-top: var(--space-lg);
        }

        @media (max-width: 768px) {
          .process-grid {
            grid-template-columns: 1fr;
          }
        }

        .process-card {
          background: var(--bg-card);
          border: 1px solid var(--border-light);
          padding: var(--space-md);
          text-align: center;
          transition: all 0.3s ease;
        }

        .process-card:hover {
          border-color: var(--brand-orange);
          transform: translateY(-4px);
        }

        .process-number {
          font-size: 3rem;
          font-weight: 900;
          color: var(--brand-orange);
          line-height: 1;
          margin-bottom: 1rem;
        }

        .process-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 0.75rem;
        }

        .process-description {
          color: var(--text-secondary);
          font-size: 1rem;
        }

        /* Company Presentation Section */
        .company-presentation-section {
          background: var(--bg-section-alternate);
          position: relative;
        }

        .presentation-box {
          max-width: 1100px;
          margin: 0 auto;
        }

        .presentation-title {
          font-family: 'Inter', sans-serif;
          font-weight: 800;
          font-size: clamp(2rem, 4vw, 3.5rem);
          line-height: 1.3;
          color: var(--text-primary);
          text-align: center;
          margin-bottom: 3rem;
        }

        .presentation-content {
          display: flex;
          flex-direction: column;
          gap: 2.5rem;
        }

        .presentation-intro,
        .presentation-description,
        .presentation-commitment {
          font-size: 1.125rem;
          line-height: 1.8;
          color: var(--text-secondary);
          text-align: center;
        }

        .presentation-intro {
          font-size: 1.25rem;
          color: var(--text-primary);
        }

        .presentation-commitment {
          font-size: 1.25rem;
          color: var(--text-primary);
          background: white;
          padding: 2rem;
          border-left: 4px solid var(--brand-orange);
          border-radius: 0.5rem;
        }

        .presentation-intro strong,
        .presentation-description strong,
        .presentation-commitment strong {
          color: var(--brand-orange);
          font-weight: 700;
        }

        .experience-badge {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          background: linear-gradient(135deg, var(--brand-blue), var(--brand-orange));
          border-radius: 1rem;
          color: white;
          max-width: 300px;
          margin: 0 auto;
        }

        .badge-number {
          font-size: 4rem;
          font-weight: 900;
          line-height: 1;
        }

        .badge-text {
          font-size: 1.125rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-top: 0.5rem;
        }

        .sectors-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.5rem;
          margin: 2rem 0;
        }

        @media (max-width: 1024px) {
          .sectors-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .sectors-grid {
            grid-template-columns: 1fr;
          }
        }

        .sector-item {
          background: white;
          padding: 2rem 1.5rem;
          border-radius: 0.75rem;
          border: 2px solid var(--border-light);
          text-align: center;
          transition: all 0.3s ease;
        }

        .sector-item:hover {
          border-color: var(--brand-orange);
          transform: translateY(-4px);
          box-shadow: 0 8px 16px rgba(255, 107, 53, 0.1);
        }

        .sector-icon {
          font-size: 2rem;
          font-weight: 900;
          color: var(--brand-blue);
          margin-bottom: 1rem;
          font-family: 'Inter', sans-serif;
        }

        .sector-label {
          font-size: 0.95rem;
          font-weight: 600;
          color: var(--text-primary);
          line-height: 1.4;
        }

        /* CTA Section */
        .cta-card {
          background: var(--bg-card);
          border: 2px solid var(--brand-blue);
          padding: var(--space-lg);
          border-radius: 1rem;
        }

        @media (max-width: 768px) {
          .hero-section {
            min-height: 70vh;
          }

          .display-title {
            font-size: 2.5rem;
          }

          .hero-cta {
            flex-direction: column;
          }

          .hero-cta .btn-primary,
          .hero-cta .btn-secondary {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default Home;
